import { SuccessfulApiResponse } from "@eryxcoop/appyx-comm";

export default class DashboardChannelsResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: {
                channels: [],
            },
            errors: [],
        };
    }

    channels() {
        return this.content().channels;
    }
}
